<template>
	<router-link :to="link" :class="wrapperClass">
		<img
            v-if="user.avatar"
            :class="avatarClass"
            :src="`/images/avatar/${user.id}`"
            :alt="`Profile photo for ${user.name}`"
            :key="user.id"
        />
        <span v-else v-text="initials" :class="{ ...avatarClass, 'initials': true }"/>
		<div class="card__content">
			<h3 :class="{ 'h2': !small && !tiny }">{{ user.name }}</h3>
			<p>{{ user.member }}</p>
		</div>
	</router-link>
</template>

<script>
	export default {
		name: 'UserCard',
		props: {
			user: {
				type: Object,
				required: true,
			},
			small: {
				type: Boolean,
				default: false,
			},
			tiny: {
				type: Boolean,
				default: false,
			},
			borderless: {
				type: Boolean,
				default: false,
			}
		},
		computed: {
			link() {
				return { name: 'view-user', params: { user_id: this.user.id }};
			},
            wrapperClass: function() {
                return {
                    'card': true,
                    'card--borderless': this.borderless,
                    'card--user': true,
                    'card--user-small': this.small,
                    'card--user-tiny': this.tiny,
                };
            },
            avatarClass: function() {
                return {
                    'avatar': true,
                    'avatar--small': this.small,
                    'avatar--tiny': this.tiny
                };
            },
            initials: function(){
                if(!this.user.name)
                    return "";

                return this.user.name.split(" ").map((namePart) => namePart[0]).join("");
            }
		}
	}
</script>

<style lang="scss">
	@import '~reflex-grid/scss/includes/variables';
	@import '~reflex-grid/scss/includes/mixins';
	@import '~@/theme/_variables.scss';
	@import '~@/mixins/_class.scss';
	@import '~@/theme/_extenables.scss';

	.card.card--user {
		display: flex;
		align-items: center;

		.avatar {
			margin-right: 1.5rem;
            align-self: flex-start;

            &.initials {
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 900;
                background-color: $accent;
                color: white;
                font-family: Axiforma, sans-serif;
            }
		}

		.card__content {
			h3, .h2 {
                line-height: 1.1;
				color: black;
				margin-bottom: 0;

				@include respond-to(medium) {
					margin-bottom: 0;
				}
			}

			p {
				color: $text;
				margin: 0;
			}
		}
	}
</style>
